<template>
  <div class="input-range" :class="{ accepted: accepted, error: error }">
    <h6 class="label">{{ label }}</h6>
    <div class="d-flex justify-content-between align-items-center">
      <div class="number-input mb-3">
        <input
          type="number"
          :min="min"
          :max="max"
          :value="computedValue"
          @input="updateValue"
          @focus="focusInput = true"
          @blur="focusInput = false"
        />
        <div class="unit">
          <span class="invisible">{{ computedValue }}</span>
          <span>&nbsp;{{ unit }}</span>
        </div>
      </div>
      <fa icon="check" class="checkmark" />
      <fa icon="exclamation" class="exclamation" />
    </div>
    <div class="slider-container position-relative">
      <div class="slider-bg" />
      <input
        :id="`${id}_slider`"
        class="input-range-slider position-absolute top-0 left-0"
        type="range"
        :min="min"
        :max="max"
        :value="computedValue"
        @input="updateValue"
        :tabindex="-1"
      />
    </div>
    <div class="error-msg mt-3">{{ errorMsg }}</div>
  </div>
</template>
<script>
export default {
  name: "input-range",
  props: {
    id: String,
    label: String,
    min: String,
    max: String,
    modelValue: String,
    defaultValue: String,
    unit: String,
    state: String,
  },
  watch: {
    modelValue: {
      immediate: true,
      handler() {
        this.isDefault = false;
        this.$nextTick(() => {
          let slider = document.getElementById(`${this.id}_slider`);
          if (!slider) return;
          let range = slider.max - slider.min;
          let value = slider.value - slider.min;
          let percent = (value * 100) / range;
          let color =
            "linear-gradient(to right, var(--slider-color) " +
            percent +
            "%, transparent " +
            percent +
            "%)";
          slider.style.background = color;
        });
      },
    },
  },
  computed: {
    computedValue() {
      if (this.isDefault) {
        return this.defaultValue;
      }
      return this.modelValue;
    },
    accepted() {
      return (
        !this.focusInput &&
        !this.isDefault &&
        this.state &&
        this.state.startsWith("ACCEPTED")
      );
    },
    error() {
      return !this.focusInput && this.state && this.state.startsWith("ERROR");
    },
    errorMsg() {
      return this.error && this.state.split("ERROR").pop();
    },
  },
  data() {
    return {
      focusInput: false,
      isDefault: false,
    };
  },
  methods: {
    updateValue(event) {
      this.$emit("update:modelValue", event.target.value);
    },
  },
  mounted() {
    if (!this.modelValue && this.defaultValue) {
      this.isDefault = true;
    }
  },
};
</script>